import { useMemo } from "react";
import { router } from "react-query-kit";
import {
  deleteRequest,
  getPagedRequest,
  QueryParams,
  saveRequest,
  useBaseUrl,
  useInvalidate
} from "@services/api/requests.service";
import { useFilterStore } from "@src/app/filters/filter.hook";
import { FilterFormData } from "@src/app/filters/FilterForm";
import { FilterProps } from "./filter.types";

export default function useFiltersApi() {
  const baseUrl = useBaseUrl("/filters");

  const { setFilters } = useFilterStore();
  const filtersApi = useMemo(
    () =>
      router("filters", {
        page: router.query({
          fetcher: async (queryParams: QueryParams) => {
            const fetchedFilters = await getPagedRequest<FilterProps>(
              baseUrl,
              queryParams
            );
            setFilters(fetchedFilters);
            return fetchedFilters;
          }
        }),
        upsert: router.mutation({
          mutationFn: (data: FilterFormData) =>
            saveRequest<FilterProps>(baseUrl, data)
        }),
        remove: router.mutation({
          mutationFn: (id: number) => deleteRequest(`${baseUrl}/${id}`)
        })
      }),
    [baseUrl, setFilters]
  );

  const invalidate = useInvalidate(filtersApi);

  return {
    usePageQuery: filtersApi.page.useQuery,
    useSaveMutation: filtersApi.upsert.useMutation,
    useRemoveMutation: filtersApi.remove.useMutation,
    invalidate
  };
}
